import { render, staticRenderFns } from "./paginas.vue?vue&type=template&id=3966eff8&"
import script from "./paginas.vue?vue&type=script&lang=js&"
export * from "./paginas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports